import React from "react"
import './CommitteeCard.scss'

function CommitteeCard({ logo, name, description }) {

    return (
        <div className={`committee-card`}>
            <div className={`logo logo-${logo}`}></div>
            <div className="name">{name}</div>
            <div className="description">{description}</div>
        </div >
    );
}

export default CommitteeCard;